import { render, staticRenderFns } from "./EditCollectionModal.vue?vue&type=template&id=187e5199&scoped=true&"
import script from "./EditCollectionModal.vue?vue&type=script&lang=js&"
export * from "./EditCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCollectionModal.vue?vue&type=style&index=0&id=187e5199&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e5199",
  null
  
)

export default component.exports